import { useEffect, useState } from 'react'
import Footer from '../../Components/Footer';
import TextBox from 'devextreme-react/text-box';
import SelectBox from 'devextreme-react/select-box';
import DateBox from 'devextreme-react/date-box';
import { disableSaturdayAndSundays } from '../../Helpers/DateBoxHelpers';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useCart } from '../../Providers/CartProvider';
import { toast } from 'react-toastify';
import { useOffers } from '../../Providers/OffersProvider';
import { IoIosAddCircleOutline } from "react-icons/io";
import AddInvestor from './Components/AddInvestor';
import { OverlayTrigger, Popover } from "react-bootstrap";
import LoadingSpinner from '../../Components/Components/LoadingSpinner';
import OfferRequestHeaderSection from './Components/OfferRequestHeaderSection';
import OfferRequestItemsTable from './Components/OfferRequestItemsTable';
import { useAuth } from '../../Providers/AuthProvider';
import OfferRequestRetailerOfferTable from './Components/OfferRequestRetailerOfferTable';
import OfferRequestSideBar from './Components/OfferRequestSideBar';
import RetailerOfferSideBar from './Components/RetailerOfferSideBar';
import useCheckUserRole from '../../Components/BasketPage/Hooks/useCheckUserRole.ts';
import NoAccess from '../../Components/NoAccess';
import { UserRole } from '../../Data/UserRolesEnum.ts';
import AddOwnPosition from '../../Components/Components/Modals/AddOwnPosition.jsx';
import ErrorBoundary from '../../Components/ErrorBoundary/ErrorBoundary.jsx';
import InformationErrorModal from '../../Components/Components/Modals/InformationErrorModal.jsx';
import YesNoMessageModal from '../../Components/Components/Modals/YesNoMessageModal.jsx';
import useCheckLicense from '../../Hooks/useCheckLicense.ts';
import { Licenses } from '../../Data/Licenses.ts';
import useCheckPrice from './Hooks/useCheckPrice.jsx';
import useCheckCustomerHasPriceList from '../../Components/BasketPage/Hooks/useCheckCustomerHasPriceList.jsx';
import ScrollUpArrow from '../../Components/Components/ScrollUpArrow.jsx';

import './Styles/OfferRequestStyles.css'

const OfferRequest = () => {
    let dateNow = new Date()
    const { checkLicense } = useCheckLicense()
    const [isValidLicense, setIsValidLicense] = useState(checkLicense([Licenses.TgInstalacje]))

    const { mode, forceLoad, requestOfferNo } = useParams() // 0- zapytanie ofertowe lub gdy PH oferta, 1 - oferta dla detalisty        
    const location = useLocation()
    const { product } = location.state || {}
    debugger
    const navigate = useNavigate()
    const { authState } = useAuth()

    const { investors, handleRequestForOffer, handleGetInvestors, handleSendRetailerOffer, handleCreateCustomerOffer, handleGetSavedOffer, handleCreateUpdateSavedOffer,
        handleDeleteSavedOffer, setSavedOfferId, handleGetCurrentSavedOfferId, handleCreateUpdateSavedOfferInvestObject, handleGetSavedOfferInvestObject, setEditOfferRequestOfferNo
    } = useOffers()

    const { cartItems, getBasketTotalValue } = useCart()
    const [offerRequest, setOfferRequest] = useState({
        investor: null, investName: '', additionalInfo: '', expectedDate: dateNow.setDate(dateNow.getDate() + 14), retailerTax: 23,
        totalPriceMarkup: 0, serviceNetValue: 0
    })
    const [products, setProducts] = useState([])
    const [showAddInvestorModal, setShowAddInvestorModal] = useState(false)
    const [newInvestor, setNewInvestor] = useState({ objectId: -1, name: '', zipCode: '', city: '', street: '', houseNum: '', localNum: '', objectTypeId: '', description: '', isAdded: false })
    const [newInvestorWasAdded, setNewInvestorWasAdded] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const { isUserHasAccess } = useCheckUserRole()
    const [ownProductCounter, setOwnProductCounter] = useState(1)
    const [showAddPositionModal, setShowAddPositionModal] = useState(false)
    const [showIncorrectPriceError, setShowIncorrectPriceError] = useState(false)
    const [showIncorrectQtyError, setShowIncorrectQtyError] = useState(false)
    const [showIncorrectMarkupError, setShowIncorrectMarkupError] = useState(false)
    const [showLoadDataModal, setShowLoadDataModal] = useState(false)
    const [savedOfferVM, setSavedOfferVM] = useState(null)
    const { handleCheckMinimumPrice } = useCheckPrice()
    const [savedOfferInvestObject, setSavedOfferInvestObject] = useState(null)
    const [selectedInvestorObject, setSelectedInvestorObject] = useState(null)
    const [showConfirmOfferModal, setShowConfirmOfferModal] = useState(false)
    const { checkCustomerHasPriceList } = useCheckCustomerHasPriceList()
    const [isUserHasPriceList, setIsUserHasPriceList] = useState(false)
    const [isUserHasPriceListLoading, setIsUserHasPriceListLoading] = useState(true)

    const [cartTotalNet, setCartTotalNet] = useState(0)
    const [cartTotalGross, setCartTotalGross] = useState(0)
    const [cartTotalTax, setCartTotalTax] = useState(0)

    useEffect(() => {
        if (mode == 0 && products && products.length > 0) {
            var result = getBasketTotalValue(products)
            setCartTotalNet(result.totalNet)
            setCartTotalGross(result.totalGross)
            setCartTotalTax(result.totalTax)
        }
        else {
            setCartTotalNet(0)
            setCartTotalGross(0)
            setCartTotalTax(0)
        }
    }, [products])

    useEffect(() => {
        debugger
        const handleOnLoad = async () => {
            var isUserHasPriceListResult = true
            if (authState.user.isOperator) {
                setIsUserHasPriceListLoading(true)
                isUserHasPriceListResult = await checkCustomerHasPriceList(authState.custId)
                setIsUserHasPriceList(isUserHasPriceListResult)
                setIsUserHasPriceListLoading(false)
            }
            if (isValidLicense && isUserHasPriceListResult) {
                setSavedOfferId(-1)
                handleFetchSavedOffer()
            }
        }

        handleOnLoad()
    }, [])

    useEffect(() => {
        if (isValidLicense && products && products.length > 0) {
            handleCreateUpdateSavedOffer(mode, offerRequest, products)
        }
    }, [products.length, offerRequest.investor, offerRequest.investName, offerRequest.additionalInfo, offerRequest.expectedDate, offerRequest.retailerTax])

    useEffect(() => {
        setNewInvestorWasAdded(newInvestor.isAdded)
        if (newInvestor && newInvestor.isAdded) {
            handleCreateUpdateSavedOfferInvestObject(mode, newInvestor, true)
        }
    }, [newInvestor.isAdded])

    useEffect(() => {
        if (products.length > 0) {
            setProducts(prev =>
                prev.map(item => ({
                    ...item,
                    costGross: parseFloat(item.costNet * (1 + offerRequest.retailerTax / 100)),
                    totalCostGross: parseFloat(item.costNet * (1 + offerRequest.retailerTax / 100)),
                    product: {
                        ...item.product,
                        priceGros: parseFloat(item.product.priceNet * (1 + offerRequest.retailerTax / 100)),
                        taxRate: offerRequest.retailerTax
                    }
                }))
            )
        }
    }, [offerRequest.retailerTax])

    useEffect(() => {
        if (offerRequest.investor) {
            var tmpInvestorObject = { objectId: offerRequest.investor.value.objectId }
            handleCreateUpdateSavedOfferInvestObject(mode, tmpInvestorObject, false)
        }
    }, [offerRequest.investor])

    useEffect(() => {
        if (savedOfferInvestObject && investors && investors.length > 0) {
            if (savedOfferInvestObject.objectId && savedOfferInvestObject.objectId != -1) { //tutaj mamy zapisany id obieku z ferrodo
                const paddedId = savedOfferInvestObject.objectId.toString().padStart(6, '0')
                const investorObject = investors.find(i => i.objectId === paddedId)
                setSelectedInvestorObject(investorObject)
            }
            else if (savedOfferInvestObject && savedOfferInvestObject.objectId == -1) { //tutaj mamy zapisany customowy obiekt do dodania                
                setNewInvestor({
                    objectId: -1, name: savedOfferInvestObject.investName, zipCode: savedOfferInvestObject.zipCode, city: savedOfferInvestObject.city, street: savedOfferInvestObject.street, houseNum: savedOfferInvestObject.houseNo,
                    localNum: savedOfferInvestObject.localNo, objectTypeId: savedOfferInvestObject.objectTypeId, description: savedOfferInvestObject.investDesc, isAdded: true
                })
            }
            else {
                setSelectedInvestorObject(null)
            }
        }
        else if (!savedOfferInvestObject) {
            setSelectedInvestorObject(null)
        }
    }, [savedOfferInvestObject, investors])

    const handleUpdateSavedOfferAfterEdit = () => {
        if (products && products.length > 0) {
            handleCreateUpdateSavedOffer(mode, offerRequest, products)
        }
    }

    const handleLoadDataModalAnswer = async (answer, savedOfferVMFromParam) => {
        if (answer) {
            let headerData = savedOfferVMFromParam ? savedOfferVMFromParam.savedOffer : savedOfferVM.savedOffer
            let offerItems = savedOfferVMFromParam ? savedOfferVMFromParam.basketItems : savedOfferVM.basketItems
            setOfferRequest({ investor: null, investName: headerData.investor, additionalInfo: headerData.additionalInfo, expectedDate: headerData.expectedDate, retailerTax: headerData.taxRate, totalPriceMarkup: 0, serviceNetValue: 0 })
            setProducts(offerItems)
            if (mode == '1') {//Zwiększenie countera pozycji własnych
                let ownProducts = offerItems.filter(p => p.externalArticle)
                if (ownProducts.length > 0) {
                    const ownProductsIndexes = ownProducts.map(p => {
                        return parseInt(p.artNo, 10)
                    })
                    if (ownProductsIndexes.length > 0) {
                        let maxIndex = Math.max(...ownProductsIndexes)
                        setOwnProductCounter(maxIndex + 1)
                    }
                }
            }
            const savedOfferInvestObjectResult = await handleGetSavedOfferInvestObject(mode)
            setSavedOfferInvestObject(savedOfferInvestObjectResult)
            handleGetInvestors()
        }
        else {
            handleCreateNewOffer()
        }
        setShowLoadDataModal(false)
    }

    const handleFetchSavedOffer = async () => {
        setIsLoading(true)
        let savedOfferVM = await handleGetSavedOffer(mode)
        if (forceLoad == 'true') { //tryb powrotu z dodawania pozycji, automatycznie wczytujemy koszyk bez pytania
            setSavedOfferVM(savedOfferVM)
            handleLoadDataModalAnswer(true, savedOfferVM)
            setIsLoading(false)
        }
        else {
            if (savedOfferVM.savedOffer.offerId && savedOfferVM.basketItems.length > 0) {
                setSavedOfferVM(savedOfferVM)
                setIsLoading(false)
                setShowLoadDataModal(true)
            }
            else {
                handleCreateNewOffer()
            }
        }
        setIsLoading(false)
    }

    const handleCreateNewOffer = () => {
        if (product) {
            const basketItemFromProduct = [{
                artNo: product.index,
                costGross: product.priceGross,
                costNet: product.priceNet,
                currency: product.currency,
                custId: authState.custId,
                isSelected: true,
                product: product,
                qty: 1,
                retailerMarkup: 0,
                totalCost: product.priceNet,
                totalCostGross: product.priceGross,
                userId: authState.user.userId,
                externalArticle: false,
            }]
            setProducts(sortProductDesc(basketItemFromProduct))
        }
        else {
            if (cartItems && cartItems.basketItems) {
                setProducts(sortProductDesc(cartItems.basketItems.filter(bi => bi.isSelected))) //tylko zaznaczone w koszyku
            }
            else { //wejście bez pozycji w koszyku
                setProducts([])
            }
        }
        handleGetInvestors()
    }

    const sortProductDesc = (products) => {
        return [...products].sort((a, b) => {
            const numA = parseInt(a.artNo.match(/\d+/)?.[0] || "0")
            const numB = parseInt(b.artNo.match(/\d+/)?.[0] || "0")
            return numB - numA
        })
    }

    const handleTextBoxValueChange = (e, prop) => {
        setOfferRequest(prev => ({
            ...prev,
            [prop]: e.value
        }))
    }

    const handleSelectBoxValueChange = (e) => {
        setSelectedInvestorObject(e.value)
        setOfferRequest(prev => ({
            ...prev,
            investor: e
        }))
    }

    const handleDateChange = (e) => {
        if (e) {
            setOfferRequest(prev => ({
                ...prev,
                expectedDate: e
            }))
        }
    }

    const handleRemoveProduct = (index) => {
        if (products.length <= 1) {
            toast.warning('Nie możesz usunąć wszystkich pozycji z oferty!')
            return
        }
        setProducts(products.filter(p => p.product.index !== index))
    }

    const handleSendOfferRequest = async () => {
        if (!validData(false)) {
            return
        }
        setIsLoading(true)
        if (await handleRequestForOffer(offerRequest, products, newInvestor)) {
            handleDeleteSavedOffer(mode)
            setSavedOfferId(-1)
            toast.success('Pomyślnie wysłano zapytanie ofertowe')
            navigate('/Offers', { state: { params: { selectedTab: 'Zapytania' } } })
        }
        else {
            toast.error('Błąd w trakcie składania zapytania ofertowego!')
        }
        setIsLoading(false)
    }

    const handleSendRetailerOfferFunc = async () => {
        if (!validData(true)) {
            return
        }
        setIsLoading(true)
        if (await handleSendRetailerOffer(offerRequest, products, newInvestor)) {
            handleDeleteSavedOffer(mode)
            setSavedOfferId(-1)
            toast.success('Pomyślnie zapisano ofertę dla klienta')
            navigate('/Offers', { state: { params: { selectedTab: 'Moje' } } })
        }
        else {
            toast.error('Błąd w trakcie wysyłania oferty dla klienta!')
        }
        setIsLoading(false)
    }

    const handleSendOfferFomPH = async () => {
        const productHasUnconfirmedPrice = products.some(product => product.isPriceConfirmed === false)
        if (productHasUnconfirmedPrice) {
            setShowIncorrectPriceError(true)
            return
        }

        setIsLoading(true)
        for (const p of products) {
            const result = await handleCheckMinimumPrice(authState.custId, p.artNo, p.costNet)
            if (!result) {
                setIsLoading(false)
                setShowIncorrectPriceError(true)
                return
            }
        }

        if (!validData(false)) {
            setIsLoading(false)
            return
        }
        setIsLoading(false)
        setShowConfirmOfferModal(true)
    }

    const handleConfirmOfferMessageModalAnswer = async (answer) => {
        setIsLoading(true)
        let funResult = await handleCreateCustomerOffer(offerRequest, products, newInvestor, answer, requestOfferNo)
        if (funResult == -1) {
            setShowConfirmOfferModal(false)
        }
        else if (funResult) {
            handleDeleteSavedOffer(mode)
            setSavedOfferId(-1)
            let selectedTabName = ''
            if (answer) {
                selectedTabName = 'OfertyTG'
                toast.success('Pomyślnie zapisano ofertę dla klienta, oferta została automatycznie zaakceptowana')
            }
            else {
                selectedTabName = 'Zapytania'
                toast.success('Pomyślnie zapisano ofertę dla klienta')
            }
            setShowConfirmOfferModal(false)
            navigate('/Offers', { state: { params: { selectedTab: selectedTabName } } })
        }
        else {
            setShowConfirmOfferModal(false)
            toast.error('Błąd w trakcie wysyłania oferty dla klienta!')
        }
        setIsLoading(false)
    }

    const validData = (isRetailerOffer) => {
        const productHasEmptyQtyValue = products.some(product => isNaN(product.retailerMarkup))
        if (productHasEmptyQtyValue) {
            setShowIncorrectQtyError(true)
            return false
        }

        if (isRetailerOffer) {
            const productHasEmptyMarkupValue = products.some(product => isNaN(product.qty))
            if (productHasEmptyMarkupValue) {
                showIncorrectMarkupError(true)
                return false
            }
        }

        if (!offerRequest.expectedDate) {
            toast.warning('Proszę uzupełnić date')
            return false
        }
        return true
    }

    const handleModalOnHide = () => {
        setShowAddInvestorModal(false)
    }

    const generateTable = () => {
        if (mode == '0' || (authState.user && authState.user.isOperator)) {
            return (<OfferRequestItemsTable
                products={products}
                setProducts={setProducts}
                handleRemoveProduct={handleRemoveProduct}
                handleUpdateSavedOfferAfterEdit={handleUpdateSavedOfferAfterEdit}
                cartTotalNet={cartTotalNet}
                cartTotalGross={cartTotalGross}
                cartTotalTax={cartTotalTax}
            />)
        }
        else {
            return (<OfferRequestRetailerOfferTable
                products={products}
                setProducts={setProducts}
                handleRemoveProduct={handleRemoveProduct}
                retailerTax={offerRequest.retailerTax}
                handleUpdateSavedOfferAfterEdit={handleUpdateSavedOfferAfterEdit}
            />)
        }
    }

    const handleAddOwnProduct = (param) => {
        if (param) {
            var newProduct = {
                artNo: ownProductCounter.toString().padStart(9, '0'),
                costGross: parseFloat(param.price * (1 + offerRequest.retailerTax / 100)),
                costNet: parseFloat(param.price),
                currency: "PLN",
                custId: authState.custId,
                isSelected: true,
                product: {
                    priceNet: parseFloat(param.price),
                    priceGros: parseFloat(param.price * (1 + offerRequest.retailerTax / 100)),
                    decimalPlaces: 0,
                    index: ownProductCounter.toString().padStart(9, '0'),
                    title: param.name,
                    label: '',
                    whId: authState.whId,
                },
                qty: 1,
                retailerMarkup: 0,
                totalCost: parseFloat(param.price),
                totalCostGross: parseFloat(param.price * (1 + offerRequest.retailerTax / 100)),
                userId: authState.userId,
                externalArticle: true,
            }
            setProducts(prev => [...prev, newProduct])
            setOwnProductCounter(prev => prev + 1)
        }
        setShowAddPositionModal(false)
    }

    const handleDeleteSavedOfferFunc = () => {
        handleDeleteSavedOffer(mode)
        navigate('/shop')
    }

    const handleAddProductClick = async () => {
        setEditOfferRequestOfferNo(requestOfferNo)
        if (products && products.length > 0) {
            let currentSavedOfferId = await handleGetCurrentSavedOfferId(mode)
            setSavedOfferId(currentSavedOfferId)
        }
        else {
            let offerId = await handleCreateUpdateSavedOffer(mode, offerRequest, []) //Dodajemy nagłowek aby było do czego dopisać pozycje
            setSavedOfferId(offerId)
        }
        navigate('/shop')
    }

    const popover = <Popover id="popover-basic">
        <Popover.Body>
            <div className='d-flex flex-column'>
                <span>{`Nazwa: ${newInvestor.name}`}</span>
                <span>{`Adres: ${newInvestor.street} ${newInvestor.houseNum} ${newInvestor.localNum.trim() != '' ? `/ ${newInvestor.localNum}` : ``}`}</span>
                <span>{`Kod pocztowy: ${newInvestor.city} ${newInvestor.zipCode}`}</span>
                <span>{`Opis: ${newInvestor.description}`}</span>
            </div>
        </Popover.Body>
    </Popover>

    const dateBoxPlaceholder = mode == '1' || (authState.user && authState.user.isOperator) ? 'Data ważności:' : 'Oczekiwana data przygotowania oferty'
    const addOwnProductButtonStyle = mode == '0' ? 'hidden' : ''
    const addProductsButtonsStyle = !products || products.length === 0 ? 'hidden' : ''

    if (authState.user.isOperator) {
        if (isUserHasPriceListLoading) {
            return <LoadingSpinner loadingText='Sprawdzanie cennika kontrahenta...' />
        }
        else if (!isUserHasPriceList) {
            return <InformationErrorModal
                show={true}
                setShow={() => navigate(-1)}
                title={'Brak cennika dla kontrahenta'}
                message={'Kontrahent nie ma wygenerowanego cennika! \n Spróbuj  ponownie za chwilę.'}
                isError={true}
                showCloseButton={false}
            />
        }
    }
    if (!isValidLicense) {
        return <NoAccess isLicenseError={true} />
    }
    if (!isUserHasAccess(UserRole.Offers)) {
        return <NoAccess />
    }
    if (mode == 1 && authState.user.isOperator) {
        return <NoAccess isLicenseError={false} customErrorText='Przedstawiciel handlowy nie może utworzyć oferty dla detalisty!' />
    }
    if (isLoading) {
        return <LoadingSpinner />
    }
    return (
        <>
            <ErrorBoundary>
                <ScrollUpArrow />
                <div className="container-fluid container-fluid-with-paddings">
                    <YesNoMessageModal
                        show={showLoadDataModal}
                        onHide={handleLoadDataModalAnswer}
                        title={'Wczytać dane?'}
                        message={<>
                            <span>Masz nie zakończoną ofertę/zapytanie ofertowe. Wczytać zapisane dane? Odrzucenie wczytania spowoduje usunięcie poprzednio zapisanych danych!</span>
                            <br />
                            <span>Załadowane zostaną pozycje z koszyka.</span>
                        </>}
                        showCloseButton={false}
                    />
                    <InformationErrorModal
                        show={showIncorrectQtyError}
                        setShow={() => { setShowIncorrectQtyError(false) }}
                        title={'Niepoprawna ilość!'}
                        message={'Na liście znajdują się produkty, których ilość jest nieuzupełniona! Aby wysłać ofertę popraw ilości!'}
                        isVersionControlInfo={false}
                        showCloseButton={false}
                        isError={true}
                    />
                    <InformationErrorModal
                        show={showIncorrectMarkupError}
                        setShow={() => { setShowIncorrectMarkupError(false) }}
                        title={'Niepoprawny narzut!'}
                        message={'Na liście znajdują się produkty, których narzut jest nieuzupełniony! Aby wysłać ofertę popraw narzut!'}
                        isVersionControlInfo={false}
                        showCloseButton={false}
                        isError={true}
                    />
                    <InformationErrorModal
                        show={showIncorrectPriceError}
                        setShow={() => { setShowIncorrectPriceError(false) }}
                        title={'Niepoprawna cena!'}
                        message={'Na liście znajdują się produkty, których cena jest poniżej dopuszczalnej kwoty minimalnej! Aby wysłać ofertę popraw ceny!'}
                        isVersionControlInfo={false}
                        showCloseButton={false}
                        isError={true}
                    />
                    <YesNoMessageModal
                        show={showConfirmOfferModal}
                        onHide={handleConfirmOfferMessageModalAnswer}
                        title={'Zatwierdzenie oferty'}
                        message={'Czy chcesz od razu zatwierdzić ofertę?'}
                        showCloseButton={false}
                    />

                    <AddOwnPosition
                        show={showAddPositionModal}
                        onHide={handleAddOwnProduct}
                    />
                    <div className="row mt-4">
                        <OfferRequestHeaderSection
                            mode={mode}
                        />
                    </div>
                    <div className="row">
                        <div className="col-12 col-xxl-9">
                            <div className="main-container-holder mt-4">
                                <div className="row">
                                    <div className="col-12 col-xl">
                                        <div className="row d-flex align-items-center ">
                                            <div className="col">
                                                {newInvestorWasAdded ? (
                                                    <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover}>
                                                        <span className='success-text-color'> Nowe miejsce inwestycji zostanie dodane po wysłaniu zapytania</span>
                                                    </OverlayTrigger>
                                                ) : (
                                                    <SelectBox
                                                        items={investors}
                                                        value={selectedInvestorObject}
                                                        placeholder="Miejsce inwestycji"
                                                        noDataText='Brak miejsc inwestycji, proszę dodać nowe'
                                                        onValueChanged={(e) => handleSelectBoxValueChange(e)}
                                                        displayExpr={(item) => item ? `"${item.name.toUpperCase()}" ${item.streetAndNumber} ${item.zipCodeAndCity}` : ''}
                                                    />
                                                )}
                                            </div>
                                            <div className="col-1">
                                                <IoIosAddCircleOutline color='green' cursor={'pointer'} size={30} style={{ marginLeft: '-15px' }} onClick={() => setShowAddInvestorModal(prev => !prev)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-xl mt-2 mb-2 mt-xl-0 mb-xl-0">
                                        <div className='d-flex align-items-center'>
                                            <span className='me-2'>{dateBoxPlaceholder}</span>
                                            <DateBox
                                                acceptCustomValue={false}
                                                type="date"
                                                displayFormat="yyyy-MM-dd"
                                                onValueChange={handleDateChange}
                                                min={Date.now()}
                                                value={offerRequest.expectedDate}
                                                disabledDates={disableSaturdayAndSundays}
                                                calendarOptions={{
                                                    maxZoomLevel: 'month',
                                                    minZoomLevel: 'month'
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-xl">
                                        <TextBox
                                            value={offerRequest.investName}
                                            placeholder="Inwestor"
                                            onValueChanged={(e) => handleTextBoxValueChange(e, 'investName')}
                                        />
                                    </div>
                                    <div className="col-12 mt-2">
                                        <TextBox
                                            value={offerRequest.additionalInfo}
                                            placeholder="Informacje dodatkowe"
                                            onValueChanged={(e) => handleTextBoxValueChange(e, 'additionalInfo')}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="main-container-holder mt-4">
                                <h3 className='mt-2 mb-2'>Lista produktów</h3>
                                {generateTable()}
                            </div>
                            <div className={`main-container-holder`} style={{ borderTop: 0 }}>
                                <div className="row">
                                    <div className="col-12 col-md-auto">
                                        <button className='btn-app-secondary' onClick={handleAddProductClick}>Dodaj produkt</button>
                                    </div>
                                    <div className="col-12 col-md mt-3 mt-md-0">
                                        <button className={`btn-app-secondary ${addOwnProductButtonStyle}`} onClick={() => setShowAddPositionModal(true)}>Dodaj własną pozycję</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`col-12 col-xxl-3 mt-0 col-xxl-mt-4 ${addProductsButtonsStyle}`}>
                            <div className="main-container-holder offer-request-side-bar ms-0 mt-3 mt-xxl-0 ms-xxl-2">
                                <div className="row">
                                    {mode == '0' ? (<OfferRequestSideBar
                                        basketItems={products}
                                        handleSendOfferRequest={handleSendOfferRequest}
                                        handleSendOfferFomPH={handleSendOfferFomPH}
                                        handleDeleteSavedOffer={handleDeleteSavedOfferFunc}
                                        cartTotalNet={cartTotalNet}
                                        cartTotalGross={cartTotalGross}
                                        cartTotalTax={cartTotalTax}
                                        requestOfferNo={requestOfferNo}
                                    />)
                                        :
                                        (<RetailerOfferSideBar
                                            basketItems={products}
                                            offerRequest={offerRequest}
                                            setOfferRequest={setOfferRequest}
                                            handleSendRetailerOffer={handleSendRetailerOfferFunc}
                                            handleDeleteSavedOffer={handleDeleteSavedOfferFunc}
                                        />)}
                                </div>
                            </div>
                        </div>
                    </div>
                    <AddInvestor
                        show={showAddInvestorModal}
                        handleOnHide={handleModalOnHide}
                        newInvestor={newInvestor}
                        setNewInvestor={setNewInvestor}
                        selectedTypeId={savedOfferInvestObject ? savedOfferInvestObject.objectTypeId : -1}
                    />
                    <Footer />
                </div>
            </ErrorBoundary>
        </>
    )
}

export default OfferRequest